import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import CustomerClassificationTable from './CustomerClassificationTable';
import AddCustomerClassification from './AddCustomerClassification';
import Download from '../../MainSection/Download/Download';
import { useNavigate, useParams } from 'react-router-dom';
import CustomerClassificationColumnFilterModal from './CustomerClassificationColumnFilterModal';
import CustomerClassificationValueFilterModal from './CustomerClassificationValueFilterModal';
import { useDispatch, useSelector } from 'react-redux';
import { loadCustomerClassificationData, loadSingleCustomerClassificationData, postCustomerClassificationDatas } from '../../../redux/action';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from '../../../Constants';
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import CustomerClassificationBulkUploadModal from './CustomerClassificationBulkUploadModal';

const statusOptions = [
    { value: "8", label: "Active" },
    { value: "9", label: "Inactive" }
]

const CustomerClassification = () => {

    let dispatch = useDispatch();
    const { id: userRefId } = useParams();

    const { customerClassificationData } = useSelector((state) => state.data);
    const { singleCustomerClassificationData } = useSelector((state) => state.data);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [classificationId, setClassificationId] = useState("");
    const [selectedColumns, setSelectedColumns] = useState([
        "CUSTOMER CLASSIFICATION", "STATUS", "ACTION"
    ]);
    const [loading, setLoading] = useState(true);
    const [selectedStatusID, setSelectedStatusID] = useState(null);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);

    const handleStatusSelection = (selectedOption) => {
        if (selectedOption) {
            const statusID = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedStatusID(statusID);  // Store StatusID in state
            getData(statusID);  // Call API with both StatusID and current RoleID
        }
    };

    useEffect(() => {
        if (userRefId) {
            dispatch(loadSingleCustomerClassificationData(setDataLoading, userRefId));
        } else {
            getData();
        }
    }, [userRefId])

    const getData = (statusID) => {
        dispatch(loadCustomerClassificationData(setLoading, statusID));
    }
    // useEffect(() => {
    //     getData()
    // }, []);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const handleOpenModal = (clsId) => {
        setIsModalOpen(true);
        if (clsId) {
            dispatch(loadSingleCustomerClassificationData(setDataLoading, clsId));
            setClassificationId(clsId);
        } else {
            setClassificationId("");
        }
    };

    const handleCloseModal = () => {
        setClassificationId("");
        dispatch(loadSingleCustomerClassificationData(setDataLoading, null));
        setIsModalOpen(false);
    };

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    const handleStatusChange = (customer, statusLabel) => {
        const statusID = statusLabel === "Active" ? 8 : 9; // 8 for Active, 9 for Inactive

        const data = {
            CustomerClassificationID: customer.CustomerClassificationID,
            CustomerClassificationName: customer.CustomerClassificationName,
            StatusID: statusID,
            AddedByID: ADDED_BY_ID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postCustomerClassificationDatas(requestOption, handleCloseModal, customer.CustomerClassificationID, getData));
        // console.log(data, 'data'); // For debugging purposes
    };

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const handleClearFilters = () => {
        setSelectedStatusID(null);
        getData();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Customer Classification"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Customer Classification</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3} className='filters-col'>
                                    <Select
                                        className="react-select-container complaint-status-select"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        options={statusOptions}
                                        style={{ width: "100%" }}
                                        value={selectedStatusID ? statusOptions.find(status => status.value === selectedStatusID) : null}
                                        onChange={(selectedOption) => handleStatusSelection(selectedOption)}
                                    />
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {/* <SbAddBtn btnName="Add" onClickEffect={() => handleOpenModal("")} /> */}
                                <SbDropdownButton
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <CustomerClassificationTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                customerClassificationData={customerClassificationData}
                                loading={loading}
                                handleStatusChange={handleStatusChange}
                                selectedColumns={selectedColumns}
                                singleCustomerClassificationData={singleCustomerClassificationData}
                                userRefId={userRefId}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddCustomerClassification
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    classificationId={classificationId}
                    singleCustomerClassificationData={singleCustomerClassificationData}
                    getData={getData}
                    dataLoading={dataLoading}
                />
            }
            {
                showBulkUploadModal && <CustomerClassificationBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                    getData={getData}
                />
            }
            {showColumnFilterModal && (
                <CustomerClassificationColumnFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {showValueFilterModal && (
                <CustomerClassificationValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {/* {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default CustomerClassification;